import { jsx } from "react/jsx-runtime";
import { useClassName, useComposeRef, useAutoHeightTextArea } from "@contember/react-utils";
import { deprecate, isDefined, dataAttribute } from "@contember/utilities";
import { memo, forwardRef, useRef } from "react";
import { useTextBasedInput } from "../Hooks/useTextBasedInput.js";
import { toViewClass } from "../../../utils/toViewClass.js";
const TextareaInput = memo(forwardRef(({
  cacheMeasurements,
  onHeightChange,
  className,
  focusRing = true,
  maxRows,
  minRows,
  rows,
  style,
  withTopToolbar,
  ...outerProps
}, forwardedRef) => {
  deprecate("1.3.0", isDefined(onHeightChange), "`TextareaInput.onHeightChange` prop", null);
  deprecate("1.3.0", isDefined(cacheMeasurements), "`TextareaInput.cacheMeasurements` prop", null);
  if (typeof rows === "number" && (typeof minRows === "number" || typeof maxRows === "number")) {
    throw new Error("TextareaInput: `rows` prop cannot be used with `minRows` or `maxRows` simultaneously");
  }
  minRows = minRows ?? rows ?? 3;
  maxRows = maxRows ?? rows ?? Infinity;
  if (minRows < 1) {
    throw new Error("TextareaInput: `minRows` prop cannot be less than 1");
  }
  if (maxRows < 1) {
    throw new Error("TextareaInput: `maxRows` prop cannot be less than 1");
  }
  const { value, ref, ...props } = useTextBasedInput({
    ...outerProps,
    className: useClassName("textarea-input", [
      toViewClass("withTopToolbar", withTopToolbar),
      className
    ])
  }, forwardedRef);
  const innerRef = useRef(null);
  const composeRef = useComposeRef(forwardedRef, innerRef);
  useAutoHeightTextArea(innerRef, value ? `${value}` : "", minRows, maxRows);
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      ...props,
      ref: composeRef,
      "data-rows": dataAttribute(rows),
      "data-min-rows": dataAttribute(minRows),
      "data-max-rows": dataAttribute(maxRows),
      "data-focus-ring": dataAttribute(focusRing),
      value,
      style,
      rows: minRows
    }
  );
}));
TextareaInput.displayName = "TextareaInput";
export {
  TextareaInput
};
//# sourceMappingURL=TextareaInput.js.map
